import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TelefoneMaskDirectiveModule } from '../../../directives';
import { TrTelComponent } from './tr-tel.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TelefoneMaskDirectiveModule,
    ],
    exports: [ TrTelComponent ],
    declarations: [ TrTelComponent ],
})
export class TrTelModule {}
